import { MapPin, ArrowUpRight } from "lucide-react";
import { scrollToId } from "../lib/scroll";

const Footer = () => (
  <footer className="bg-[#0055FF] text-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="bg-white px-3 py-1.5 inline-flex">
              <img src="/frantiger-logo.png" alt="frantiger" className="h-6 w-auto" />
            </span>

            <span className="font-display font-black tracking-tight text-lg" style={{ fontWeight: 900 }}>
              labs
            </span>
          </div>
          <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-sm">
            The campus incubation operating system. Promoting entrepreneurship in
            the most dynamic way — one campus at a time.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 px-3.5 py-1.5 border border-white/25 font-mono-x text-[10px] uppercase tracking-[0.2em] text-white/70">
            <MapPin className="w-3.5 h-3.5" /> HQ — Bengaluru, IN · 12.97°N 77.59°E
          </div>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-mono-x text-xs uppercase tracking-[0.25em] text-white/50">Navigate</h4>
          <ul className="mt-5 space-y-3">
            {[["manifesto", "The Manifesto"], ["legacy", "Our Legacy"], ["perks", "Student Perks"], ["faq", "FAQ"]].map(([id, label]) => (
              <li key={id}>
                <button
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollToId(id)}
                  className="text-sm text-white/80 hover:text-white transition-colors"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="font-mono-x text-xs uppercase tracking-[0.25em] text-white/50">The Ecosystem</h4>
          <ul className="mt-5 space-y-3">
            <li>
              <a
                data-testid="footer-frantiger-agency-link"
                href="https://frantiger.agency"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-1.5 text-sm text-white/80 hover:text-white transition-colors"
              >
                frantiger® agency
                <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </li>
            <li>
              <a
                data-testid="footer-frantiger-biz-link"
                href="https://frantiger.biz"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-1.5 text-sm text-white/80 hover:text-white transition-colors"
              >
                frantiger.biz
                <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </li>
            <li>
              <a
                data-testid="footer-email-link"
                href="mailto:frantiger.consulting@gmail.com"
                className="text-sm text-white/80 hover:text-white transition-colors"
              >
                frantiger.consulting@gmail.com
              </a>
            </li>
          </ul>
          <div className="mt-8 flex gap-3">
            <button
              data-testid="footer-cta-vibe-check"
              onClick={() => scrollToId("apply")}
              className="px-5 py-3 bg-white text-[#0055FF] font-mono-x text-xs uppercase tracking-[0.15em] hover:bg-[#0A0D14] hover:text-white transition-colors"
            >
              Vibe Check
            </button>
            <button
              data-testid="footer-cta-invite"
              onClick={() => scrollToId("apply-student")}
              className="px-5 py-3 border border-white/40 text-white font-mono-x text-xs uppercase tracking-[0.15em] hover:bg-white hover:text-[#0055FF] transition-colors"
            >
              Invite Us
            </button>
          </div>
        </div>
      </div>

      <div className="mt-16 select-none pointer-events-none" aria-hidden="true">
        <div className="font-display font-black text-outline-blue leading-none tracking-tight text-[16vw] lg:text-[11rem] whitespace-nowrap" style={{ fontWeight: 900 }}>
          frantiger labs
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-3">
        <span className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-white/50">
          © 2026 frantiger® labs · A frantiger® initiative
        </span>
        <span className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-white/50">
          Zero to funded, on campus
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
